import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Header } from "@/components/Header";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Connexion réussie");
      navigate(location.state?.from || (u.role === "admin" ? "/admin" : "/mes-videos"));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-luxe min-h-screen">
      <Header />
      <div className="max-w-md mx-auto px-6 pt-36 pb-24">
        <h1 className="font-display text-3xl text-[#F5F3EE] text-center">Connexion</h1>
        <p className="mt-3 text-sm text-[#8F8F8F] text-center">Accédez à vos vidéos achetées</p>
        <form onSubmit={submit} className="mt-10 bg-[#141414] border border-white/10 p-8 space-y-5" data-testid="login-form">
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-widest text-[#8F8F8F]">Email</Label>
            <Input
              id="email" type="email" data-testid="login-email-input" value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="jean@email.com" required
              className="mt-2 rounded-none border-white/15 bg-transparent text-[#F5F3EE] placeholder:text-[#5A5A5A] focus-visible:ring-[#D4AF37]"
            />
          </div>
          <div>
            <div className="flex items-center justify-between">
              <Label htmlFor="password" className="text-xs uppercase tracking-widest text-[#8F8F8F]">Mot de passe</Label>
              <Link to="/mot-de-passe-oublie" data-testid="forgot-password-link" className="text-xs text-[#D4AF37] hover:underline">
                Mot de passe oublié ?
              </Link>
            </div>
            <Input
              id="password" type="password" data-testid="login-password-input" value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required
              className="mt-2 rounded-none border-white/15 bg-transparent text-[#F5F3EE] placeholder:text-[#5A5A5A] focus-visible:ring-[#D4AF37]"
            />
          </div>
          <button
            type="submit" data-testid="login-submit-button" disabled={loading}
            className="w-full bg-[#D4AF37] text-[#0A0A0A] font-semibold py-4 text-sm uppercase tracking-widest hover:bg-[#C9A227] transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Se connecter
          </button>
          <p className="text-center text-sm text-[#8F8F8F]">
            Pas de compte ?{" "}
            <Link to="/inscription" state={location.state} data-testid="go-register-link" className="underline text-[#D4AF37]">
              Créer un compte
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
